module.exports = __webpack_public_path__ + "img/section2-boxImg2.0d1c824e.png";